import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import { useDispatch, useSelector } from "react-redux";
import { getTrainers, updatePackage } from "../../redux/actions/api/apiAction";
import { createPackage } from "../../redux/actions/api/apiAction";
import { store } from "../../redux/storeConfig/store";
import { convertToSeconds, generatePtGroupTiersObj } from "./utils";
import { toastr } from "react-redux-toastr";
import {
  buildPeakOffPeakPrices,
  emptyTimePrice,
} from "./peakOffPeakPricing";
import { packageVoiceSchema } from "./voiceAddSchema";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";

const renderStep = (step, values, errors, touched, setFieldValue, trainers) => {
  switch (step) {
    case 1:
      //console.log("step 1");
      return (
        <FormFirstStep
          errors={errors}
          touched={touched}
          values={values}
          setFieldValue={setFieldValue}
        />
      );
  }
};

function MultiStepForPackage({
  title,
  price,
  memberShipType,
  pt,
  session,
  duration,
  days,
  mode,
  description,
  capacity,
  courtDurations,
  disableOnlineBooking,
  waitingList,
  waitingListCapacity,
  waitingListRule,
  freeTrial,
  allowCancellation,
  allowUnPaidBooking,
  cancelationWindowUnit,
  cancelBefore,
  lastCancellationTimeInSeconds,
  extraPersonFee,
  tiers,
  supportInsurance,
  courtUsageUnit,
  forMatchMaking,
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getTrainers(
        1,
        1000,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );
  }, [dispatch]);
  let { trainers } = useSelector((state) => state.trainer);
  const [step, setStep] = useState(1);
  const [back, setBack] = useState(0);
  const handleSubmit = async (values) => {
    if (saveVoiceDraftEdit(values)) return;
    const { gymConfig } = store.getState().gym;
    const packagePriceUpdatesEnabled = Boolean(
      gymConfig?.manageMemberships?.appointmentMemberships?.enabled &&
        gymConfig?.manageMemberships?.appointmentMemberships
          ?.ptGroupPricing &&
        gymConfig?.manageMemberships?.appointmentMemberships
          ?.ptGroupPricing?.enabled
    );
    const hasPeakOffPeakPricing =
      packagePriceUpdatesEnabled &&
      values.memberShipType === "court" &&
      Boolean(values.hasPeakOffPeakPricing);

    // Validation for PT packages with capacity > 1
    if (
      packagePriceUpdatesEnabled &&
      values?.memberShipType === "pt" &&
      values.capacity > 1
    ) {
     const {valid,reason,tiers}= generatePtGroupTiersObj({pricingType:values.pricingType,extraPersonFee:values.extraPersonFee,price:values.price,capacity:values.capacity,tiers:values.tiers})
     if(!valid) return toastr.error(reason)
     values.tiers=tiers
    }
    if (
      values.isSharedPackage &&
      values.memberShipType === "GYM" &&
      (!values.sharedBranches || !values.sharedBranches.length)
    ) {
      return toastr.error("Select at least one branch to share with");
    }
    let requestJson = {
      name: values.title,
      sessionCount: values.session.toString(),
      planType: values.memberShipType,
      price: hasPeakOffPeakPricing ? 0 : values.price,
      type: values.mode,
      durationType: values.duration,
      durationCount: values.days,
      hasClassessAccess: values.hasClassessAccess,
      allowTransfereBookings: values?.allowTransfereBookings,
      courts: values?.courts?.length ? values.courts.map(c => c.value) : [],
      sharedBetweenFamily: values?.sharedBetweenFamily,
      isforTrainerOnly: values.isforTrainerOnly,
      gender: values.gender,
      requiredAttachment: values.requiredAttachment,
      sharedBranches: values.isSharedPackage ? values.sharedBranches : [],
      poolAccessType: values.poolAccessType,
      capacity: values.capacity,
      count: values.session.toString(),
      courtDurations: values.courtDurations,
      // SESSION is deliberately sent for old-style court packages. The backend
      // must only convert sessionCount to minutes when this value is MINUTE.
      forMatchMaking:
        values.memberShipType === "court" && Boolean(values.forMatchMaking),
      courtUsageUnit:
        values.memberShipType === "court" &&
        (values.forMatchMaking || values.courtUsageUnit === "MINUTE")
          ? "MINUTE"
          : "SESSION",
      disableOnlineBooking: values.disableOnlineBooking,
      waitingList: values.waitingList,
      waitingListCapacity: values.waitingListCapacity,
      waitingListRule: values.waitingListRule,
      freeTrial: values.freeTrial,
      allowCancellation: values.allowCancellation,
      allowUnPaidBooking: values.allowUnPaidBooking,
      cancelationWindowUnit: values.cancelationWindowUnit,
      cancelBefore: values.cancelBefore,
      lastCancellationTimeInSeconds: convertToSeconds(
        values.cancelBefore,
        values.cancelationWindowUnit
      ),
      supportInsurance:values.supportInsurance,
    };
    if (packagePriceUpdatesEnabled) {
      requestJson.tiers = values.tiers;
      requestJson.hasGroupPricing = Boolean(values.tiers.length);
      requestJson.hasPeakOffPeakPricing = hasPeakOffPeakPricing;
      requestJson.peakOffPeakPrices = buildPeakOffPeakPrices({
        ...values,
        hasPeakOffPeakPricing,
      });
    }
    const { packageEdit, editFields } = store.getState().sidebar;
    if (packageEdit) {
      await store.dispatch(updatePackage(requestJson, editFields.id));
    } else {
      await store.dispatch(createPackage(requestJson));
    }
  };

  const submit = (values, actions) => {
    if (values.duration === "M") values.days *= 30;
    handleSubmit(values);
  };

  const formSchema1 = packageVoiceSchema;

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={withVoicePrefill("package", {
          title,
          price,
          memberShipType,
          pt,
          session,
          duration,
          days,
          mode,
          mixation: "single",
          hasClassessAccess: false,
          allowTransfereBookings: false,
          sharedBetweenFamily: false,
          isforTrainerOnly: false,
          isSharedPackage: false,
          courts: [],
          packageBranchesSharingType: "sharedForCustomBranches",
          sharedBranches: [],
          poolAccessType: null,
          capacity,
          courtDurations,
          disableOnlineBooking,
          waitingList,
          waitingListCapacity,
          waitingListRule,
          freeTrial,
          allowCancellation,
          allowUnPaidBooking,
          cancelationWindowUnit,
          cancelBefore,
          lastCancellationTimeInSeconds,
          extraPersonFee,
          tiers,
          supportInsurance,
          courtUsageUnit,
          forMatchMaking: false,
          hasPeakOffPeakPricing: false,
          pricingIntervals: [emptyTimePrice()],
        })}
        onSubmit={submit}
        validationSchema={formSchema1}
      >
        {({
          errors,
          touched,
          handleChange,
          handleBlur,
          values,
          setFieldValue,
        }) => (
          <Form>
            {renderStep(step, values, errors, touched, setFieldValue, trainers)}
            <StepButton step={step} />
          </Form>
        )}
      </Formik>
    </>
  );
}

MultiStepForPackage.defaultProps = {
  edit: false,
  price: "",
  title: "",
  session: "unlimited",
  pt: "",
  memberShipType: "GYM",
  duration: "D",
  days: "",
  mode: "OFFLINE",
  gender: "",
  requiredAttachment: false,
  sharedBranches: [],
  capacity: "",
  courtDurations: [],
  disableOnlineBooking: false,
  waitingList: "",
  waitingListCapacity: "",
  waitingListRule: "auto",
  freeTrial: false,
  allowCancellation: true,
  supportInsurance:false,
  courtUsageUnit: "SESSION",
  forMatchMaking: false,
  allowUnPaidBooking: false,
  cancelationWindowUnit: "d",
  cancelBefore: "",
  lastCancellationTimeInSeconds: "",
  extraPersonFee:0,
  tiers:[],
  handleSubmit: (values) => {},
};

export default MultiStepForPackage;
